<template>
    <modal
        ref="errorMessageModal"
        title="Something went wrong"
        actionText="Dismiss"
        contentClass="error-message-window"
    >
        <ul class="error--text">
            <li v-for="(error, field) in errors" :key="`error-message-${field}`">
                {{ error }}
            </li>
        </ul>
    </modal>
</template>

<script>
    import Modal from '~/components/Shared/UIComponents/Modal';

    export default {
        name: 'ErrorMessages',
        components: {
            Modal
        },
        props: {
            show5XXError: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                errors: {},
                componentHandledErrorCodes: {}
            }
        },
        watch: {
            errors: {
                async handler() {
                    if (await this.$refs.errorMessageModal.open() === false) {
                        return;
                    }

                    if (this.show5XXError && this.$root.hasOwnProperty('user')) {
                        if (
                            ["insurer", "captive_insurer"].includes(this.$root.user.company.company_type)
                        ) {
                            this.$router.push("/insurer/dashboard/");
                        } else {
                            this.$router.push("/agent/dashboard/");
                        }

                        return;
                    }

                    this.$router.go(0);
                },
                deep: true
            }
        },
        mounted() {
            this.$eventBus.$on('componentWillHandleErrorCodes', (options) => {
                this.componentHandledErrorCodes[options.componentID] = options.codesArray;
            });

            this.$eventBus.$on('clearComponentWillHandleErrorCodes', (componentID) => {
                delete this.componentHandledErrorCodes[componentID];
            });

            window.intercepted.$on('response:client-error', data => {
                // Ignore any status codes handled elsewhere
                if ([401, 403, 440].concat(this.codesHandledByComponents()).includes(data.status)) {
                    return false;
                }
                this.errors = data.body;
            });

            window.intercepted.$on('response:5xx', data => {
                console.log('5xx response');

                if (this.show5XXError) {
                    if (data.body.hasOwnProperty('show_default_msg') && data.body.show_default_msg === false && data.body?.error) {

                        this.errors = { message: data.body.error };

                        return false;
                    }
                    this.errors = {'message':'Unable to process your request at this time. please try again later.'};
                }
            });
        },
        methods: {
            codesHandledByComponents() {
                const codesArr = Object.values(this.componentHandledErrorCodes);
                return [...new Set(codesArr.flat(Infinity))];
            }
        }
    }
</script>

<style lang="scss">
    .x-dialog.error-message-window {
        z-index: 300;
    }
</style>
